<template>
  <div class="wrap">
    <div class="main">
      <div class="right">
        <h1>欢迎进入员工体检健康平台</h1>
        <!-- 登录模块 -->
        <div class="loginDiv" v-if="isLogin">
          <h3>账号登录</h3>
          <div class="username">
            <img src="../../assets/icon/证件号.svg" alt />
            <input
              @keyup.enter="loginBtn"
              type="text"
              name
              v-model="usernameInput"
              onkeyup="value=value.replace(/[\W]/g,'')"
              placeholder="请输入身份证号"
            />
          </div>

          <div class="username" slot="reference" style="margin-bottom: 10px">
            <img src="../../assets/icon/密码.svg" alt />
            <input
              @keyup.enter="loginBtn"
              type="password"
              name
              v-model="passwordInput"
              placeholder="默认密码为身份证号后六位遇X前移"
            />
          </div>

          <div class="treaty">
            <el-checkbox v-model="checked" class="checkBox_argee"></el-checkbox>
            <p>
              {{ $t("m.login.haveRead") }}
              <span @click="yhxy">{{ $t("m.login.userAgreement") }}</span>
              {{ $t("m.login.and") }}
              <span @click="yszc">{{ $t("m.login.privacyPolicy") }}</span>
            </p>
          </div>
          <el-button
            class="loginBtn"
            type="primary"
            @click="loginBtn"
            style="width: 100%; margin-top: 20px"
            :loading="loading"
            >{{ $t("m.login.register") }}
          </el-button>
          <p style="margin-top: 10px" class="forgetPwd" @click="forgetBtn">
            {{ $t("m.login.forgotPass") }}
          </p>
          <div style="font-size: 16px; color: #ff000f; margin-top: 10px">
            登录建议：建议使用谷歌浏览器或IE浏览器（11以上版本）
          </div>
        </div>
        <!-- 找回密码模块 -->
        <div class="loginDiv" v-else>
          <h3>{{ $t("m.login.resetPass") }}</h3>
          <div class="username">
            <img src="../../assets/icon/手机号.svg" alt />
            <input
              type="text"
              name
              v-model="phoneInput"
              onkeyup="value=value.replace(/[\W]/g,'')"
              :placeholder="$t('m.common.mobile')"
            />
          </div>
          <div class="username">
            <img src="../../assets/icon/验证码.svg" alt />
            <input
              type="text"
              name
              v-model="codeInput"
              :placeholder="$t('m.common.importVerification')"
            />
            <p class="codeBtn" @click="getCode" v-if="show">
              {{ $t("m.common.code") }}
            </p>
            <p class="codeBtn" v-else>{{ counts }} S</p>
          </div>
          <div class="username">
            <img src="../../assets/icon/密码.svg" alt />
            <input
              type="password"
              name
              v-model="newPwdInput"
              :placeholder="$t('m.person.newPassword')"
            />
          </div>
          <div class="username" style="margin-bottom: 10px">
            <img src="../../assets/icon/密码.svg" alt />
            <input
              type="password"
              name
              v-model="newPwdAgainInput"
              :placeholder="$t('m.person.newPasswordAgin')"
            />
          </div>
          <p class="forgetPwd" @click="backLogin">
            {{ $t("m.login.backLogin") }}
          </p>
          <el-button
            type="primary"
            @click="okBtn"
            style="width: 100%; margin-top: 10px; margin-bottom: 10px"
            :loading="loading"
            >{{ $t("m.common.define") }}</el-button
          >
        </div>
      </div>
    </div>
    <div class="newyear">2021</div>
    <div class="line"></div>
    <div class="footer">
      <p>{{ $t("m.common.footerTest") }}</p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
let phoneReg = /^1[3456789]\d{9}$/;
export default {
  props: {},
  components: {},
  data() {
    return {
      usernameInput: "",
      passwordInput: "",
      phoneInput: "",
      codeInput: "",
      newPwdInput: "",
      newPwdAgainInput: "",
      checked: false,
      loading: false,
      isLogin: true,
      counts: "",
      timer: null,
      show: true,
    };
  },
  computed: {
    ...mapGetters(["qhText"]), // 动态计算属性，相当于this.$store.getters.resturantName
  },
  methods: {
    ...mapActions(
      // 语法糖
      ["changeZH", "changeEN", "changeLangCss"] // 相当于this.$store.dispatch('modifyName'),提交这个方法
    ),
    // 获取地址栏url参数
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    //找回密码
    forgetBtn() {
      let _this = this;
      _this.isLogin = false;
      _this.phoneInput = "";
      _this.counts = 0;
      _this.codeInput = "";
      _this.newPwdInput = "";
      _this.newPwdAgainInput = "";
    },
    //返回登录
    backLogin() {
      let _this = this;
      _this.isLogin = true;
      _this.usernameInput = "";
      _this.passwordInput = "";
    },
    //确认找回密码
    okBtn() {
      let _this = this;
      if (!_this.phoneInput) {
        _this.$message({
          message: _this.$t("m.staffMsg.editDialog.errMsg.phone"),
          type: "error",
          center: true,
        });
      } else if (!phoneReg.test(_this.phoneInput)) {
        _this.$message({
          message: _this.$t("m.staffMsg.editDialog.errMsg.okPhone"),
          type: "error",
          center: true,
        });
      } else if (!_this.codeInput) {
        _this.$message({
          message: _this.$t("m.common.importVerification"),
          type: "error",
          center: true,
        });
      } else if (!_this.newPwdInput) {
        _this.$message({
          message: _this.$t("m.person.newPassword"),
          type: "error",
          center: true,
        });
      } else if (!_this.newPwdAgainInput) {
        _this.$message({
          message: _this.$t("m.person.newPasswordAgin"),
          type: "error",
          center: true,
        });
      } else if (_this.newPwdInput != _this.newPwdAgainInput) {
        _this.$message({
          message: _this.$t("m.person.passwordAtypism"),
          type: "error",
          center: true,
        });
      } else {
        _this.loading = true;
        axios
          .post(BASE_URL + "/exam/auth/mobile/verify/", {
            mobile: _this.phoneInput,
            token: _this.codeInput,
            company_code: "ABB",
            // password: _this.newPwdInput
          })
          .then((res) => {
            localStorage.setItem("TOKEN", res.data.data.token);
            if (res.data.return_code == 0) {
              axios
                .post(BASE_URL + "/exam/account/password/reset/", {
                  new_password: _this.newPwdAgainInput,
                })
                .then((res1) => {
                  _this.loading = false;
                  _this.isLogin = true;
                  _this.$message({
                    message: _this.$t("m.person.changePassSuccess"),
                    type: "success",
                    center: true,
                  });
                });
            }
          })

          .catch((err) => {
            _this.loading = false;
          });
      }
    },
    // 获取验证码
    getCode() {
      let _this = this;
      if (!_this.phoneInput) {
        _this.$message({
          message: _this.$t("m.staffMsg.editDialog.errMsg.phone"),
          type: "error",
          center: true,
        });
      } else if (!phoneReg.test(_this.phoneInput)) {
        _this.$message({
          message: _this.$t("m.staffMsg.editDialog.errMsg.okPhone"),
          type: "error",
          center: true,
        });
      } else {
        axios
          .post(BASE_URL + "/exam/auth/mobile/token/", {
            mobile: _this.phoneInput,
            company_code: "ABB",
          })
          .then((res) => {
            let TIME_COUNT = 60;
            if (!_this.timer) {
              _this.counts = TIME_COUNT;
              _this.show = false;
              _this.timer = setInterval(() => {
                if (_this.counts > 0 && _this.counts <= TIME_COUNT) {
                  _this.counts--;
                } else {
                  _this.show = true;
                  clearInterval(_this.timer);
                  _this.timer = null;
                }
              }, 1000);
            }
          });
      }
    },
    //登录功能
    loginBtn() {
      let _this = this;
      if (!_this.usernameInput) {
        _this.$message({
          message: _this.$t("m.common.certificate"),
          type: "error",
          center: true,
        });
      } else if (!_this.passwordInput) {
        _this.$message({
          message: _this.$t("m.common.inputPassword"),
          type: "error",
          center: true,
        });
      } else if (!_this.checked) {
        _this.$message({
          message: _this.$t("m.common.treaty"),
          type: "error",
          center: true,
        });
      } else {
        _this.loading = true;
        axios
          .post(BASE_URL + "/exam/auth/usercret/", {
            id_card: _this.usernameInput,
            password: _this.passwordInput,
            company_code: "ABB",
          })
          .then((res) => {
            let result = res.data;
            _this.loading = false;
            localStorage.setItem("TOKEN", result.data.token);
            axios.get(BASE_URL + "/exam/account/profile/").then((response) => {
              localStorage.setItem("username", response.data.data.realname);
              _this.$store.dispatch("setUser", response.data.data.realname);
              if (response.data.data.language === 1) {
                this.changeZH();
                localStorage.setItem("nationality", "zh");
              } else {
                this.changeEN();
                localStorage.setItem("nationality", "en");
              }
              _this.$router.push({
                path: "/phyExServices",
              });
            });
          })
          .catch((err) => {
            _this.loading = false;
          });
      }
    },

    //hr值班室
    hrBtn() {
      window.open(
        "https://applink.feishu.cn/client/helpdesk/open?id=6512629154104492302"
      );
    },
    //用户协议
    yhxy() {
      let _this = this;
      let routeLife = _this.$router.resolve({
        path: "/pdf",
        query: {
          name: "用户协议",
        },
      });
      window.open(routeLife.href);
    },
    //隐私政策
    yszc() {
      let _this = this;
      let routeLife = _this.$router.resolve({
        path: "/pdf",
        query: {
          name: "隐私政策",
        },
      });
      window.open(routeLife.href);
    },
  },
  created() {
    let _this = this;
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      console.log(121212);
      location.href = "https://exam.abb2021.lejian.com/h5/#/";
    }
    if (_this.getUrlKey("token")) {
      localStorage.setItem("TOKEN", _this.getUrlKey("token"));
      axios.get(BASE_URL + "/exam/account/profile/").then((response) => {
        localStorage.setItem("username", response.data.data.realname);
        _this.$store.dispatch("setUser", response.data.data.realname);
        if (response.data.data.language === 1) {
          this.changeZH();
          localStorage.setItem("nationality", "zh");
        } else {
          this.changeEN();
          localStorage.setItem("nationality", "en");
        }
        _this.$router.push({
          path: "/phyExServices",
        });
      });
    }
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "zh-CN");
    }

    _this.changeLangCss();
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.userlogin();
      }
    };
    if (localStorage.getItem("TOKEN") != null) {
      _this.$store.dispatch("setUser", localStorage.getItem("username"));
      _this.$router.push({
        path: "/phyExServices",
      });
    }
  },
  mounted() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      alert(
        "如果您的IE浏览器版本过低，会影响体检预约，建议使用谷歌浏览器，也可使用手机端预约，或拨打电话400 068 5099-1-6688进行预约"
      );
    }
  },
};
</script>
<style scoped lang="scss">
h1 {
  width: 100%;
  font-size: 30px;
  line-height: 42px;
  color: #333;
  font-weight: bold;
  margin-bottom: 40px;
  text-align: center;
}

.codeBtn {
  width: 92px;
  height: 30px;
  color: #fff;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #999;
  border-radius: 4px;
  cursor: pointer;
}

.zh,
.en {
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  text-decoration: underline;
  cursor: pointer;
}

.langActive {
  color: #ff000f !important;
}

.treaty {
  width: 300px;
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
  padding-right: 25px;
  word-wrap: break-word;
  p {
    width: 300px;
    margin-left: 5px;
    font-size: 12px;
    line-height: 18px;
    color: #333;
    text-align: justify;
    word-wrap: break-word;
    text-overflow: ellipsis;
    span {
      cursor: pointer;
      color: #ff000f;
      text-decoration: underline;
    }
  }
}

.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.main {
  overflow-y: scroll;
  margin-top: 80px;
  position: relative;
  flex: 1;
  background: url("../../assets/abbBG.png") no-repeat center;
  background-size: 100%;
  width: 100%;
  position: relative;
  .interpret {
    display: flex;
    align-items: center;
    position: absolute;
    top: 54px;
    left: 75%;
    .i18nAction {
      color: rgba(2, 128, 201, 1);
    }
    span {
      font-weight: 400;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      text-decoration: underline;
      cursor: pointer;
    }
    i {
      display: block;
      width: 2px;
      height: 16px;
      background: #ffffff;
      margin: 0 10px;
    }
    em {
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .msg {
    width: 650px;
    height: auto;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100px;
    left: 22%;
    span {
      font-size: 20px;
      font-weight: 800;
      color: rgba(0, 97, 153, 1);
    }
    em {
      font-size: 24px;
      font-weight: 800;
      color: rgba(0, 97, 153, 1);
      margin-top: 15px;
    }
    b {
      width: 410px;
      height: 4px;
      background: rgba(0, 97, 153, 1);
      margin-top: 20px;
    }
    i {
      font-size: 18px;
      font-weight: normal;
      color: rgba(0, 97, 153, 1);
      margin-top: 20px;
    }
  }
  .right {
    margin-bottom: 100px;
    position: absolute;
    width: 410px;
    top: 120px;
    left: 50%;
    .loginDiv {
      box-shadow: 0px 0px 50px 0px rgba(41, 45, 53, 0.15);
      border-radius: 4px;
      background: rgba(255, 255, 255, 1);
      padding: 30px;
      h3 {
        font-size: 20px;
        font-weight: 500;
        color: #333;
        line-height: 20px;
        margin-bottom: 30px;
      }
      .username {
        width: 100%;
        height: 50px;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #dfdfdf;
        display: flex;
        align-items: center;
        padding: 0 10px;
        margin-bottom: 20px;
        img {
          width: 20px;
          height: 20px;
        }
        input {
          height: 30px;
          flex: 1;
          width: 100px;
          border-left: 1px solid #dfdfdf;
          margin-left: 10px;
          padding: 0 10px;
          font-size: 14px;
          font-weight: 400;
          color: #333;
          line-height: 14px;
        }
      }
      .forgetPwd {
        font-size: 12px;
        line-height: 12px;
        color: #666;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}

.footer {
  width: 100%;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #999;
  line-height: 14px;
  background-color: #f2f2f2;
  p {
    width: 100%;
    height: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.loginBtn {
  background-color: #ff000f;
  width: 400px;
  height: 50px;
  border-radius: 25px;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ff000f;
}

.el-checkbox__inner:hover {
  border-color: #ff000f;
}

.newyear {
  position: absolute;
  bottom: 300px;
  right: 140px;
  color: #000000;
  font-size: 60px;
  font-weight: 800;
}

.line {
  width: 66px;
  height: 12px;
  position: absolute;
  right: 145px;
  bottom: 280px;
  background: #ff000f;
}
</style>


// WEBPACK FOOTER //
// src/components/login/login.vue